__turbopack_context__.v({
  "copy": "CardDualAspectNews-module-scss-module__ceMHLq__copy",
  "fade-in": "CardDualAspectNews-module-scss-module__ceMHLq__fade-in",
  "headline": "CardDualAspectNews-module-scss-module__ceMHLq__headline",
  "image": "CardDualAspectNews-module-scss-module__ceMHLq__image",
  "imageContainer": "CardDualAspectNews-module-scss-module__ceMHLq__imageContainer",
  "inner": "CardDualAspectNews-module-scss-module__ceMHLq__inner",
  "isEven": "CardDualAspectNews-module-scss-module__ceMHLq__isEven",
  "isLink": "CardDualAspectNews-module-scss-module__ceMHLq__isLink",
  "root": "CardDualAspectNews-module-scss-module__ceMHLq__root",
});
